export const REPORT_PERMISSION = 'Dramas_UGC-Reports';

export const DEFAULT_PAGE_SIZE = 20;

/** 内容类举报原因全集（展示映射 / Tag 颜色） */
export const CONTENT_REPORT_TYPE_OPTIONS = [
    { code: 'vulgar_content', color: 'magenta' },
    { code: 'illegal_activity', color: 'red' },
    { code: 'sensitive_content', color: 'orange' },
    { code: 'gang_gambling', color: 'volcano' },
    { code: 'harm_minors', color: 'purple' },
    { code: 'infringement', color: 'blue' },
    { code: 'quality_issue', color: 'cyan' },
    { code: 'dislike', color: 'default' },
    { code: 'other', color: 'default' },
] as const;

/** 作品 / 短剧 IP 举报筛选项（与后端一致，不含「我不喜欢」） */
export const WORK_DRAMA_REPORT_TYPE_OPTIONS = CONTENT_REPORT_TYPE_OPTIONS.filter(
    (item) => item.code !== 'dislike',
);

/** 评论举报筛选项（不含「质量问题」，含「我不喜欢」） */
export const COMMENT_REPORT_TYPE_OPTIONS = CONTENT_REPORT_TYPE_OPTIONS.filter(
    (item) => item.code !== 'quality_issue',
);

/** 用户举报原因（与后端 code / 顺序一致） */
export const USER_REPORT_TYPE_OPTIONS = [
    { code: 'inappropriate_profile', color: 'magenta' },
    { code: 'impersonation', color: 'red' },
    { code: 'cyberbullying', color: 'orange' },
    { code: 'pornographic_content', color: 'red' },
    { code: 'suspected_fraud', color: 'volcano' },
    { code: 'safety_threat', color: 'purple' },
    { code: 'ip_infringement', color: 'blue' },
    { code: 'other', color: 'default' },
] as const;

export const REPORT_TYPE_ALIASES: Record<string, string> = {
    // 内容类：短 code / 口语化 → canonical
    porn: 'vulgar_content',
    pornographic: 'vulgar_content',
    sexual_content: 'vulgar_content',
    vulgar: 'vulgar_content',
    illegal: 'illegal_activity',
    criminal: 'illegal_activity',
    criminal_activity: 'illegal_activity',
    sensitive: 'sensitive_content',
    political: 'sensitive_content',
    political_sensitive: 'sensitive_content',
    gambling: 'gang_gambling',
    minor: 'harm_minors',
    child_safety: 'harm_minors',
    child_abuse: 'harm_minors',
    copyright: 'infringement',
    ip_infringement: 'infringement',
    copyright_infringement: 'infringement',
    quality: 'quality_issue',
    low_quality: 'quality_issue',
    dislike: 'dislike',
    i_dont_like: 'dislike',

    // 用户类：后端 code / 别名 → i18n canonical
    cyberbullying: 'cyber_violence',
    cyber_bullying: 'cyber_violence',
    online_harassment: 'cyber_violence',
    harassment: 'cyber_violence',
    inappropriate_profile: 'profile_violation',
    profile_abuse: 'profile_violation',
    bad_profile: 'profile_violation',
    profile_violation: 'profile_violation',
    safety_threat: 'personal_safety',
    personal_threat: 'personal_safety',
    threat_to_safety: 'personal_safety',
    personal_safety: 'personal_safety',
    impersonating: 'impersonation',
    fake_identity: 'impersonation',
    fake_account: 'impersonation',
    identity_impersonation: 'impersonation',
    scam: 'fraud',
    fraudulent: 'fraud',
    financial_fraud: 'fraud',
    suspected_fraud: 'fraud',
    fraud: 'fraud',
    cyber_violence: 'cyber_violence',
};

export const WORK_KIND_OPTIONS = [
    { value: 'SHORT_VIDEO' as const, color: 'cyan' },
    { value: 'DRAMA_EPISODE' as const, color: 'purple' },
];

export const REPORT_TIME_PRESETS = [
    { value: 'LAST_7_DAYS' as const },
    { value: 'LAST_30_DAYS' as const },
    { value: 'CUSTOM' as const },
];
